export const bodyMapper = (_bodyMapper, data, acc = {}) => {
    for (let i = 0; i < _bodyMapper.length; i++) {
        const _map = _bodyMapper[i];
        if (typeof _map === 'string') {
            acc[_map] = typeof data[_map] === 'undefined' ? null : data[_map];
        }
        else {
            const entities = Object.entries(_map);
            for (let i = 0; i < entities.length; i++) {
                const [key, value] = entities[i];
                acc[key] = bodyMapper(value, data[key] || {}, acc[key] || {});
            }
        }
    }
    return acc;
};
// Flattens nested objects into single level keys joined by "_", so a webhook
// receiver that cannot read nested JSON still gets every value. Arrays are not
// representable this way and become null. Mirrors the flattening the sender
// applies in @debbie/hooks, which cannot import this package.
export const deepFlattenToObject = (obj, prefix = '') => Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '_' : '';
    if (typeof obj[k] === 'object' && obj[k] !== null) {
        if (Array.isArray(obj[k])) {
            acc[pre + k] = null;
        }
        else {
            Object.assign(acc, deepFlattenToObject(obj[k], pre + k));
        }
    }
    else {
        acc[pre + k] = obj[k];
    }
    return acc;
}, {});
export var HookItemState;
(function (HookItemState) {
    HookItemState["Pending"] = "PENDING";
    HookItemState["Success"] = "SUCCESS";
    HookItemState["FailedAndNotified"] = "FAILED_AND_NOTIFIED";
    HookItemState["FailedAwatingNotification"] = "FAILED_AWATING_NOTIFICATION";
    HookItemState["FailedNoNotification"] = "FAILED_NO_NOTIFICATION";
})(HookItemState || (HookItemState = {}));
// The events a creditor may subscribe to. Every one of them is routed with a
// creditorId at the emit site, so a creditor scoped hook only ever receives
// its own creditor's data.
export var CreditorWebhookEvent;
(function (CreditorWebhookEvent) {
    CreditorWebhookEvent["BillingCreated"] = "billings.create";
    CreditorWebhookEvent["CaseCreated"] = "cases.create";
    CreditorWebhookEvent["CaseUpdated"] = "cases.update";
    CreditorWebhookEvent["CaseDeleted"] = "cases.delete";
})(CreditorWebhookEvent || (CreditorWebhookEvent = {}));
export const creditorWebhookEvents = Object.values(CreditorWebhookEvent);
//# sourceMappingURL=index.js.map